import { render, staticRenderFns } from "./quickPage.vue?vue&type=template&id=260b4f7a&scoped=true&"
import script from "./quickPage.vue?vue&type=script&lang=js&"
export * from "./quickPage.vue?vue&type=script&lang=js&"
import style0 from "./quickPage.vue?vue&type=style&index=0&id=260b4f7a&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260b4f7a",
  null
  
)

component.options.__file = "quickPage.vue"
export default component.exports